import React from "react";
import Menu from "../../menu";

const Header2Nav = (props) => {
  const { logged, cp, navSections, segmentMenu, municipios, municipio } = props;
  const selector = logged ? "logged" : "default";
  return (
    <div className="header2-nav container">
      <div className="menu">
        <div className="section-menu" data-cy="Header links">
          {navSections && navSections[selector] && (
            <Menu items={navSections[selector]} layout="default" location="menu"/>
          )}
        </div>
        <div className="segment-menu" data-cy="Header secondary links">
          {segmentMenu && segmentMenu[selector] && (
            <Menu items={segmentMenu[selector]} layout="default" location="menu" />
          )}
        </div>
      </div>
      <div className="options">
        <Menu
          layout="cp"
          location="menu"
          cp={cp}
          municipios={municipios}
          municipio={municipio}
        />
      </div>
    </div>
  );
};
export default Header2Nav;
